<template>
  <div>
    <CModal :show.sync="activeDelete" centered :draggable="false">
      <template slot="header-wrapper">
        <div/>
      </template>
      Etes-vous sûrs de vouloir supprimer {{activeDeleteName ? activeDeleteName : `la sélection`}} ?
      <template slot="footer">
        <CButton color="secondary" class="mr-2" @click="activeDelete = false; selectedIds = []">
          Non
        </CButton>
        <CButton
          color="primary"
          @click="deleteFonctions(selectedIds)"
          data-cy="confirm-delete-button"
        >
          Oui
        </CButton>
      </template>
    </CModal>
    <ReferenceTableActions
      table-name="fonction"
      manageButtonContent="Supprimer la sélection"
      :buttons="['create', 'template', 'manage-button', 'upload', 'export']"
      :disabledButtons="!selectedIds.length ? ['manage-button'] : []"
      @create="showCreate"
      @template="downloadFile({
                fileName: 'fonction_template.xlsx',
                downloadURL: FONCTION_ENDPOINTS.template,
             })"
      @manage-button="activeDelete = true; activeDeleteName = null"
      @upload="uploadFonctions"
      @export="downloadFile({
          downloadURL: FONCTION_ENDPOINTS.export,
          query: $refs.fonctionsTable.tableQuery
        })"
    />
    <table-component
      :encode-filters="false"
      :filterExcludeColumns="['actions']"
      @row-selected="rowSelected"
      keep-id
      :should-allow-row-selection="true"
      :init-filters="filters"
      :columns="tableColumns"
      :headings="tableHeadings"
      :url="FONCTION_ENDPOINTS.base"
      :pagination-text-position="'bottom'"
      ref="fonctionsTable"
    >
      <template slot="level" slot-scope="{ row }">
        {{ row.level }}
      </template>
      <template slot="row-selection-button">
        <div/>
      </template>
      <template slot="actions" slot-scope="{ row }">
        <div class="d-flex flex-wrap" style="row-gap: 0.25em; column-gap: 0.5em">
          <CButton
            class="sm outline action-button"
            color="primary"
            size="sm"
            variant="outline"
            @click="showEdit(row)"
          >
            <em class="fa fa-edit"/>
            Modifier
          </CButton>
          <CButton
            class="action-button"
            color="danger"
            size="sm"
            @click="activeDelete = true; selectedIds=[row._id]; activeDeleteName = row.fonction"
            data-cy="delete-button"
          >
            <em class="fa fa-close"/>
            Supprimer
          </CButton>
        </div>
      </template>
    </table-component>
    <CModal
      :show.sync="showModal"
      :draggable="false"
      :resizable="false"
      centered
    >
      <template slot="header">
        {{ isEdit ? "Modification de fonction" : "Création d'une nouvelle fonction" }}
      </template>
      <div class="bg-extended-color44 p-2 mb-2" v-if="!canCreate">
        Required fields are missing
      </div>
      <div class="d-flex flex-column gap-2">
        <MzSelect
          searchable
          required
          label="Certification Code"
          :disabled="isEdit"
          :options="availableCodes"
          :value.sync="newFonction.certification_code"
        />
        <CInput
          required
          :disabled="isEdit"
          class="danger"
          label="Fonction"
          v-model="newFonction.fonction"
        />
        <CInput
          label="Fonction (EN)"
          v-model="newFonction.fonction_en"
        />
        <CInput
          label="Fonction (ZH)"
          v-model="newFonction.fonction_zh"
        />
        <MzSelect
          style="padding-bottom: 92px"
          label="Cible"
          :options="availableCibles"
          :value.sync="newFonction.niveau_fonction"
        />
      </div>
      <template slot="footer">
        <div>
          <CButton
            color="secondary"
            class="mr-2"
            @click="showModal=false"
          >
            Annuler
          </CButton>
          <CButton
            color="primary"
            :disabled="!canCreate"
            @click="isEdit ? updateFonction() : createFonction()"
          >
            Sauvegarder
          </CButton>
        </div>
      </template>
    </CModal>
  </div>
</template>

<script>
import ReferenceTableActions from "@/components/ReferenceTableActions";
import {FONCTION_ENDPOINTS, FonctionService} from "@/services/fonction";
import {CertService} from "@/services/certification";
import {downloadFile} from "@/utils/request";
import {FilesService} from "@/services/files";


export default {
  name: "Fonctions",
  components: {
    ReferenceTableActions
  },
  data() {
    return {
      activeDeleteName: null,
      canCreate: true,
      selectedIds: [],
      selectedFonctions: null,
      isEdit: false,
      isUploading: false,
      showModal: false,
      activeDelete: false,
      availableCodes: [],
      filters: {},
      availableCibles: [
        "Littérale",
        "P+1",
        "Proche"
      ],
      clearFonction: {
        certification_code: "",
        fonction: "",
        fonction_en: "",
        fonction_zh: "",
        niveau_fonction: "",
      },
      newFonction: {},
      FONCTION_ENDPOINTS,
      tableColumns: [
        "certification_code",
        "fonction",
        "fonction_en",
        "fonction_zh",
        "niveau_fonction",
        "actions",
      ],
      tableHeadings: {
        "fonction_en": "Fonction (EN)",
        "fonction_zh": "Fonction (ZH)",
        "niveau_fonction": "Cible",
      },
    }
  },
  async mounted() {
    this.newFonction = this.clearFonction;
  },
  computed: {
    requiredFieldsFilled() {
      return !!this.newFonction.certification_code && !!this.newFonction.fonction
    }
  },
  watch: {
    newFonction: {
      handler() {
        if (this.requiredFieldsFilled) this.canCreate = true
      },
      deep: true
    }
  },
  methods: {
    downloadFile,
    async refreshTableData() {
      await this.$refs.fonctionsTable.$refs.table.getData()
    },
    async deleteFonctions(Ids) {
      this.saveFilters();
      const {res} = await FonctionService.deleteFonction(Ids);
      if (res.status !== 200) alert("Something went wrong");
      this.activeDelete = false;
      await this.refreshTableData()
    },
    async uploadFonctions(files) {
      this.isUploading = true;
      await FilesService.uploadFile({
        file: files[0],
        url: FONCTION_ENDPOINTS.base + "upload/",
        onError: (res) => {
          alert(res.detail);
          this.isUploading = false;
        },
        onSuccess: (res) => {
          alert(res.message);
        }
      });
      this.isUploading = false;
      await this.refreshTableData()
    },
    saveFilters() {
      this.filters = {};
      Object.entries(this.$refs.fonctionsTable.tableQuery).forEach((filter) => {
        if (!["byColumn", "order_by", "page", "per_page"].includes(filter[0])) {
          this.filters[filter[0]] = filter[1];
        }
      });
    },
    rowSelected(selected) {
      this.selectedIds = selected.map((fonction) => fonction._id)
    },
    showEdit(fonction) {
      this.showModal = true
      this.isEdit = true
      this.newFonction = {...fonction};
    },
    async showCreate() {
      this.canCreate = true
      const {data} = await CertService.getAvailableCodes();
      this.availableCodes = data
      this.newFonction = {}
      this.isEdit = false
      this.showModal = true
    },
    async updateFonction() {
      this.saveFilters();
      const {res} = await FonctionService.updateFonction(this.newFonction._id, {
        fonction_en: this.newFonction.fonction_en,
        fonction_zh: this.newFonction.fonction_zh,
        niveau_fonction: this.newFonction.niveau_fonction,
      });
      if (res.status !== 200) alert("Something went wrong");
      this.isEdit = false
      this.newFonction = this.clearFonction;
      this.showModal = false;
      await this.refreshTableData()
    },
    async createFonction() {
      this.saveFilters();
      if (!this.requiredFieldsFilled) {
        this.canCreate = false
        return
      }
      const {res} = await FonctionService.createFonction({
        certification_code: this.newFonction.certification_code,
        fonction: this.newFonction.fonction,
        fonction_en: this.newFonction.fonction_en,
        fonction_zh: this.newFonction.fonction_zh,
        niveau_fonction: this.newFonction.niveau_fonction,
      });
      if (res.status === 422) {
        alert(
          `Fonction "${this.newFonction.fonction}" already exists for ${this.newFonction.certification_code}`
        );
      }
      else {
        this.showModal = false;
        await this.refreshTableData()
      }
      this.newFonction = this.clearFonction;
    },
  }
}
</script>
